/**
 * 环境名
 * @returns inside -》开发环境，test -》测试环境， 现网环境 -》''
 */
let ENV_NAME = ''
let VUE_APP_INTERACTIVE = ''
try {
    const res = wx.getAccountInfoSync()
    const _appId = res.miniProgram.appId
    switch (_appId) {
      case 'wx0c3417205d9852a9':  // 主干环境
        ENV_NAME = 'inside'
        VUE_APP_INTERACTIVE = 'https://alive_interactive.inside.xiaoeknow.com'
        break
      case 'wxb58a41ffda339bf5':  // 测试环境
        ENV_NAME = 'test'
        VUE_APP_INTERACTIVE = 'https://alive-interactive.test.xiaoeknow.com'
        break
      case 'wx13a74d0d3ab0942e':  // 正式环境
        ENV_NAME = ''
        VUE_APP_INTERACTIVE = 'https://alive-interactive.xiaoeknow.com'
        break
      default:
        break
    }
} catch (error) {
    console.log("error", error)
}

export { ENV_NAME, VUE_APP_INTERACTIVE }